export default async function createCalc(
  user, // admin or user
  targetUserID, // target user
  answers,
  calcType,
  calcData,
  welcomeEmail = false,
  isPDFGenerated = false
) {
  // query l=1 means this is from a landing page
  // default with no query param won't send a welcome email to the user
  const createTargetUrl = `${process.env.CMS_URL}/calcs?l=${
    welcomeEmail ? 1 : 0
  }`;

  const name = answers?.filter((answer) => {
    return answer?.q_title === "Calculation name";
  })?.[0]?.a_string;

  const address = answers?.filter((answer) => {
    return answer?.q_title === "Address (optional)";
  })?.[0]?.a_string;

  let resData;
  const token = await user.getIdToken();
  try {
    const res = await fetch(createTargetUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        UID: targetUserID,
        Answers: answers,
        Name: name,
        Address: address,
        CalcType: calcType,
        CalcData: calcData,
        PDFGenerated: isPDFGenerated,
      }),
    });
    resData = await res.json();
  } catch (error) {
    console.log("error creating user profile");
    console.log(error);
  }

  return resData;
}
